var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "AutomationTitle" } },
    [
      _c(
        "div",
        {
          staticClass:
            "block-title-container d-flex flex-row justify-content-center align-items-center",
        },
        [
          _c("IconButton", { attrs: { "on-click": _vm.goBack } }, [
            _c("span", { staticClass: "material-icons cb-back-button" }, [
              _vm._v(" chevron_left "),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "title-content" }, [
            _c("input", {
              ref: "editStoryName",
              staticClass: "title-input",
              attrs: { placeholder: _vm.$t("chatbotv2.typeAutomationTitle") },
              domProps: { value: _vm.name },
              on: {
                input: function ($event) {
                  _vm.name = $event.target.value
                },
                blur: function ($event) {
                  return _vm.updateName()
                },
              },
            }),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "description-container",
                on: { click: _vm.openDescriptionEditor },
              },
              [
                _vm.description
                  ? _c("span", { staticClass: "description-text" }, [
                      _vm._v(_vm._s(_vm.description)),
                    ])
                  : _c("span", { staticClass: "description-placeholder" }, [
                      _vm._v(_vm._s(_vm.$t("automation.addDescription"))),
                    ]),
                _vm._v(" "),
                _c("span", { staticClass: "material-icons edit-icon" }, [
                  _vm._v("edit"),
                ]),
              ]
            ),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "a-modal",
        {
          attrs: {
            title: _vm.$t("automation.editDescription"),
            footer: null,
            width: 500,
          },
          model: {
            value: _vm.descriptionModalVisible,
            callback: function ($$v) {
              _vm.descriptionModalVisible = $$v
            },
            expression: "descriptionModalVisible",
          },
        },
        [
          _c(
            "div",
            { staticClass: "description-edit-modal" },
            [
              _c("a-textarea", {
                attrs: {
                  placeholder: _vm.$t("automation.descriptionPlaceholder"),
                  "auto-size": { minRows: 3, maxRows: 8 },
                },
                model: {
                  value: _vm.descriptionEdit,
                  callback: function ($$v) {
                    _vm.descriptionEdit = $$v
                  },
                  expression: "descriptionEdit",
                },
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "modal-actions" },
                [
                  _c(
                    "a-button",
                    {
                      on: {
                        click: function ($event) {
                          _vm.descriptionModalVisible = false
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("common.cancel")))]
                  ),
                  _vm._v(" "),
                  _c(
                    "a-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.saveDescription },
                    },
                    [_vm._v(_vm._s(_vm.$t("common.save")))]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }